import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_07b2fcda";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_07b2fcda" };
/** script content **/
require("./time-picker-popup.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex07b2fcda%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ftime-picker-popup%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_07b2fcda"],
    ctorType: "component",
    outputPath: "components/index07b2fcda/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker-popup-base': getComponent(require("../picker-popup/picker-popup-base.mpx?isComponent&outputPath=components%2Fpicker-popup-base146a305a%2Findex")), 'cube-time-picker': getComponent(require("../time-picker/index.mpx?isComponent&outputPath=components%2Findex057b2bbb%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
